var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{staticClass:"d-flex justify-content-center",attrs:{"align-h":"center"}},[_c('a',{attrs:{"target":"_blank","href":"https://github.com/Ben-Chapman/EVFinder"}},[_c('b-icon-github',{staticClass:"icon",attrs:{"aria-hidden":"true","font-scale":"1.3"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }